module.exports = __webpack_public_path__ + "static/media/PersonalPage.682d0e25.png";